import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import SparkLogo from '../components/SparkLogo';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handle = async () => {
      try {
        // Supabase auto-detects the session from URL (detectSessionInUrl: true)
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          // Manda para /app — AppIndexRedirect decide feed/dashboard pelo role
          navigate('/app', { replace: true });
        } else {
          // Wait a bit for the session to settle
          setTimeout(async () => {
            const { data: { session: s } } = await supabase.auth.getSession();
            navigate(s ? '/app' : '/auth', { replace: true });
          }, 1500);
        }
      } catch (e) {
        navigate('/auth?error=callback_failed', { replace: true });
      }
    };
    handle();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050816]">
      <div className="flex flex-col items-center gap-4">
        <SparkLogo height={48} />
        <div className="flex items-center gap-2 text-xs text-slate-400">
          <div className="w-2 h-2 rounded-full bg-[#ffa726] animate-pulse" />
          Acendendo sua Spark...
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
